module.exports = __webpack_public_path__ + "media/application/images/2018/email-green-be4fceea14eaac896290ba023d2da66a.svg";